<div class="main-loader" [hidden]="!loading">
    <img src="/assets/images/Comp-1.gif" alt="">
</div>

